<div class="tab-pane fade" id="departure" role="tabpanel" aria-labelledby="departure-tab">
        <div class="container-fluid">
            <div class="content-block">
                <div class="row align-content-center">
                    <div class="col-md-10">
                        <form>
                            <div class="form-modified">
                                <div class="form-group row align-items-center">

                                    <label for="staticEmail" class="col-sm-2 col-form-label">
                                        Quota</label>
                                    <div class="col-sm-10">
                                        <input type="text" class="form-control" id="inputPassword"
                                            placeholder="Enter segment title">
                                    </div>
                                </div>
                                <div class="form-group row align-items-center">

                                    <label for="staticEmail" class="col-sm-2 col-form-label">
                                        Departure date</label>
                                    <div class="col-sm-10">
                                        <input type="text" class="form-control" id="inputPassword"
                                            placeholder="Enter title">
                                    </div>
                                </div>

                                <div class="form-group row align-items-center">

                                    <label for="staticEmail" class="col-sm-2 col-form-label">
                                        Price</label>
                                    <div class="col-sm-10">
                                        <input type="text" class="form-control" id="inputPassword"
                                            placeholder="$">
                                    </div>
                                </div>


                                <div class="form-group row align-items-center">

                                    <label for="staticEmail" class="col-sm-2 col-form-label">Note
                                    </label>
                                    <div class="col-sm-10">
                                        <textarea name="" id="" placeholder="eg. 8 hours"></textarea>
                                    </div>
                                </div>


                                <div class="content-block">
                                    <div class="row">
                                        <div class="col-md-10 offset-md-2">
                                            <button class="btn default-btn save-btn" type="submit">Save</button>
                                        </div>
                                    </div>

                                </div>





                            </div>

                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>